import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
} from '../../components/Layout';
import {
    Button,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersReceivedSms(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQSender('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQSender && (newSearchParams['q-sender'] = filterQSender);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQSender, setFilterQSender] = useState(allProps['q-sender'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-received-sms/table-data', {
            size: tableSize,
            page: tablePage,
            q_sender: filterQSender,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>پیامک های دریافتی</Title>
                </RightComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'ارسال کننده'}
                    value={filterQSender}
                    onChange={setFilterQSender}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>پیام</TableColumn>
                        <TableColumn mobile={false}>ارسال کننده</TableColumn>
                        <TableColumn mobile={false}>نتیجه پردازش</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_message}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_sender}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_process_result}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-datetime-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
